import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState,useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from "mobx-react";
import { runInAction, action } from "mobx"
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledDropZone } from 'react-drop-zone'
import 'react-drop-zone/dist/styles.css'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Placeholder from 'react-bootstrap/Placeholder';
import Container from 'react-bootstrap/Container';
import FormText from './../inputs/text';

import FormTextArea from './../inputs/textarea';

import FormSelect from './../inputs/select';
import FormAutoComplete from './../inputs/autocomplete';
import FormDate from './../inputs/date';

import FormSwitch from './../inputs/switch';
import FormFileUpload from "./../inputs/fileupload";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { prepareForm, getUnits, getFirstOfMonth, getLastOfMonth, winbizFormatter, winbizValidator } from './../../utils';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { isZeroOne } from './../../utils';

const ActivitiesEdit = () => {

    let navigate = useNavigate();
    const { usersAdminStore, activitiesStore, projectsStore,utilsStore } = useStores();
    const { getAllUsers, users, searchConsultant } = usersAdminStore;
    const { getVATs, vatSettings } = utilsStore;
    const { searchProject } = projectsStore;
    const { getById, activity, reset, save } = activitiesStore;
    const { t, i18n } = useTranslation();    
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);   
    const [validated, setValidated] = useState(false);
    const messageForm = useRef(null);
    const isNew = () => id && id == "new";
    const [salary, setSalary] = useState(false);
    const [billable, setBillable] = useState(false);

    const [billingUnit, setBillingUnit] = useState(null);
    const [salaryUnit, setSalaryUnit] = useState(null);
    
    useEffect(() => {        
        async function fetchMyAPI() {
            setIsLoading(true);
            getVATs().then(() => {
                getById(id).then(() => {
                    setIsLoading(false);

                })
            });

            
        }
        
        if (id == "new") {
            handleReset();
            getVATs();
        } else {            
            fetchMyAPI();
            
        }

    }, [getById, reset]);

    useEffect(() => {
        setBillingUnit(activity.billingUnit?.toString() ?? null);
        setSalaryUnit(activity.salaryUnit?.toString() ?? null);
    }, [activity])

    const handleReset = () => {
        reset();        
        setValidated(false);
    };

    const goToList = () => {
        navigate("/administration/activities")
    };

    const listTVA = () => {
        return vatSettings;
    }

    const handleSubmit = (event) => {                

        event.preventDefault();

        const form = event.currentTarget;
        
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            var formData = prepareForm(event, isNew(), ["id",
                "consultantId",
                "projectId",
                "salaryUnit",
                "vatSettingId",
                "salaryUnit",
                "billingUnit",
                "workUnit",
                "billingAmount",
                "salaryAmount",
                "defaultPkgExp_Breakfast",
                "defaultPkgExp_Dinner",
                "defaultPkgExp_KM",
                "defaultPkgExp_Lodging",
                "defaultPkgExp_Lunch",
            ], ["defaultPkgExp_Breakfast", "defaultPkgExp_Dinner", "defaultPkgExp_KM", "defaultPkgExp_Lodging", "defaultPkgExp_Lunch"]);
           
            formData.startYear = formData.startDate.split("-")[0];
            formData.startMonth = formData.startDate.split("-")[1];
            formData.endYear = formData.endDate.split("-")[0];
            formData.endMonth = formData.endDate.split("-")[1];
            
            formData.billingAmount = formData.billingAmount === 0 ? null : formData.billingAmount;
            formData.salaryAmount = formData.salaryAmount === 0 ? null : formData.salaryAmount;
            formData.defaultPkgExp_Description = formData?.defaultPkgExp_Description?.length > 0 ? formData.defaultPkgExp_Description : null;          
                        
            save(formData, () => { goToList() });
        }

        setValidated(true);
    };
    


    return (       
        <Form lang="fr" noValidate validated={validated} onSubmit={handleSubmit} ref={messageForm}>
            <Card>                
                <Card.Body>
                    <div>                      
                        <Stack direction="vertical">
                            <Row>
                                
                                <Col style={{ alignSelf: "center" }}  >
                                    <ArrowBackIosIcon sx={{ color: "#d12b3c", cursor: "pointer" }} onClick={() => navigate("../activities")} size="small" />
                                    <b>{t(isNew() ? 'newActivity' : 'activity')} {!isNew() && `(Id: ${id})`}</b>
                                </Col>
                                <Col md="auto"><Button className="btn btn-danger float-end" onClick={goToList} >{t('cancel')}</Button></Col>
                                <Col md="auto"><Button type="submit" className="btn btn-secondary float-end" >{t('save')}</Button></Col>
                            </Row>

                            <hr />

                            <Row className="my-2">
                                <Col xs={8}>
                                    <FormText hidden isNumber id="id" type="number" object={activity} />

                                    <FormText required label={t("activityCode")} id="code" isLoading={isLoading} object={activity}/>
                                </Col>

                                {/*<Col xs={4}>
                                    <FormText label={t("billingText")} id="billingText" isLoading={isLoading} />
                                </Col>*/}
                            </Row>

                            <Row className="my-2">
                                <Col xs={8}>                                    
                                    <FormText required label={t("activityName")} id="name" isLoading={isLoading} object={activity} />
                                </Col>

                                {/*<Col xs={4}>
                                    <FormText label={t("billingText")} id="billingText" isLoading={isLoading} />
                                </Col>*/}
                            </Row>

                            <Row className="my-2">
                                <Col xs={4}>
                                    
                                    <FormDate required month label={t("startDate")} id="startDate" isLoading={isLoading} object={activity}/>
                                </Col>

                                <Col xs={4}>                                    
                                    <FormDate required month label={t("endDate")} id="endDate" isLoading={isLoading} object={activity} />
                                </Col>
                            </Row>

                            <Row className="my-2">
                                <Col xs={2}>
                                    <FormSwitch label={t("privacy")} id="confidential" isLoading={isLoading} object={activity}/>
                                </Col>
                                <Col xs={2}>
                                    <FormSwitch label={t("billableClient")} id="billableClient" isLoading={isLoading} object={activity} observe={(v) => setBillable(v)}/>
                                </Col>
                                <Col xs={2}>
                                    <FormSwitch label={t("salary")} id="salary" isLoading={isLoading} object={activity} observe={(v) => setSalary(v)} />
                                </Col>
                            </Row>

                            <Row className="my-2">

                                <Col xs={4}>                                    
                                    <FormAutoComplete onCreateClick={() => window.open('/administration/users/new', '_blank')} service={searchConsultant} itemFn={(option) => `${option.name} ${option.surname} (${option.username} - ID: ${option.id})`} validated={validated} required label={t("consultant")} id="consultant" formId="consultantId" isLoading={isLoading} object={activity}/>
                                </Col>
                                
                                <Col xs={4}>
                                    <FormSelect required label={t("workUnit")} id="workUnit" isLoading={isLoading} items={getUnits(null, true)} itemId="id" itemLabel="name" object={activity} />
                                </Col>
                            </Row>


                            
                            {billable && <Row className="my-2">

                                <Col xs={8}>
                                    {isLoading ? <Skeleton width={100} /> : t("billing")}
                                    <Container className="border rounded">
                                        <Row className="my-2">
                                            <Col>

                                                <FormTextArea required label={t("billingText")} id="billingText" isLoading={isLoading} object={activity} />
                                            </Col>
                                        </Row>

                                        <Row className="my-2">
                                            <Col>
                                                <FormText formatter={(v) => winbizFormatter(v)} validator={winbizValidator} required label={t("winbizCode")} id="winbizArticle" isLoading={isLoading} placeholder="Code d'article" object={activity} />
                                            </Col>

                                            <Col>
                                                {/*<FormSelect label={t("tva")} id="tva" isLoading={isLoading} items={[]} object={activity} />*/}
                                                <FormSelect required isLoading={isLoading} label={t("tva")} items={listTVA()} itemId="id" itemLabel="name" id="vatSettingId" object={activity}/* onChange={(v) => { filterByClient(v) }}*/ />
                                            </Col>

                                            <Col>
                                                <FormSelect onChange={(v) => setBillingUnit(v)} required label={t("billingUnit")} id="billingUnit" isLoading={isLoading} items={getUnits(null,true)} itemId="id" itemLabel="name" object={activity} />
                                            </Col>

                                            <Col>                                                        
                                                <FormText useFormattedInput decimalScale={2} clearOn={billingUnit === "3"} disabled={billingUnit === "3"} type="number" step="any" label={t("unitAmount")} id="billingAmount" isLoading={isLoading} object={activity} />                                                
                                            </Col>
                                        </Row>
                                        <Row className="my-2">
                                            <Col xs={6}>
                                                <FormAutoComplete onCreateClick={() => window.open('/administration/projects/new', '_blank')} service={searchProject} itemFn={(option) => `${option.name} - ID: ${option.id}`} validated={validated} required label={t("project")} id="project" formId="projectId" isLoading={isLoading} object={activity} />
                                            </Col>
                                        </Row>


                                    </Container>
                                </Col>


                            </Row>}

                            {salary && <Row className="my-2">

                                <Col xs={8}>
                                    {isLoading ? <Skeleton width={100} /> : t('salary')}
                                    <Container className="border rounded">

                                        <Row className="my-2">
                                            <Col>

                                                <FormText required label={t("winbizActivityName")} id="winbizName" isLoading={isLoading} object={activity} />
                                            </Col>
                                        </Row>
                                        

                                        <Row className="my-2">
                                            <Col>
                                                <FormText required label={t("winbizCode")} id="winbizSalary" isLoading={isLoading} placeholder="Salaire" object={activity} />
                                            </Col>

                                            <Col>
                                                <FormSelect onChange={(v) => setSalaryUnit(v)}  required label={t("salaryUnit")} id="salaryUnit" isLoading={isLoading} items={getUnits()} itemId="id" itemLabel="name" object={activity} />
                                            </Col>
                                            <Col>
                                                <FormText useFormattedInput decimalScale={2} clearOn={salaryUnit === "3"} disabled={salaryUnit === "3"} type="number" label={t("unitAmount")} id="salaryAmount" isLoading={isLoading} object={activity} />
                                            </Col>

                                        </Row>

                                        <br/>

                                        {isLoading ? <Skeleton width={100} /> : `${t('packageExpense')} - ${t("defaultValues")}`}
                                        <Row className="my-2">
                                            <Col>
                                                <FormText label={t("description")} id="defaultPkgExp_Description" isLoading={isLoading} object={activity} />
                                            </Col>
                                        </Row>
                                        <Row className="my-2">                                            
                                            <Col>
                                                <FormText label={t("km2")} id="defaultPkgExp_KM" type="number" onlyDigits isLoading={isLoading} object={activity} />
                                            </Col>
                                            <Col>
                                                {/*<FormText label={t("breakfast")} id="defaultPkgExp_Breakfast" type="number" allowDefault onlyDigits onlyZeroOne isLoading={isLoading} object={activity}  maxLength={1} />*/}
                                                <label className="form-label" htmlFor="defaultPkgExp_Breakfast">
                                                    {t("breakfast")}
                                                </label>
                                                <input
                                                    name="defaultPkgExp_Breakfast"
                                                    className="form-control"
                                                    value={activity.defaultPkgExp_Breakfast ?? ''} min={0}
                                                    max={1} type="number"
                                                    onChange={action((e) => {
                                                        if (e.target.value.length > 1) {
                                                            activity.defaultPkgExp_Breakfast = e.target.value[e.target.value.length - 1];
                                                        } else {
                                                            activity.defaultPkgExp_Breakfast = e.target.value;
                                                        }
                                                    })}
                                                    onKeyPress={isZeroOne} />
                                            </Col>
                                            <Col>
                                                {/*<FormText label={t("lunch")} id="defaultPkgExp_Lunch" type="number" allowDefault onlyDigits onlyZeroOne isLoading={isLoading} object={activity}  maxLength={1} />*/}
                                                <label className="form-label" htmlFor="defaultPkgExp_Lunch">
                                                    {t("lunch")}
                                                </label>
                                                <input
                                                    name="defaultPkgExp_Lunch"
                                                    className="form-control"
                                                    value={activity.defaultPkgExp_Lunch ?? ''} min={0}
                                                    max={1} type="number"
                                                    onChange={action((e) => {
                                                        if (e.target.value.length > 1) {
                                                            activity.defaultPkgExp_Lunch = e.target.value[e.target.value.length - 1];
                                                        } else {
                                                            activity.defaultPkgExp_Lunch = e.target.value;
                                                        }
                                                    })}
                                                    onKeyPress={isZeroOne} />
                                            </Col>
                                            <Col>
                                                {/*<FormText label={t("dinner")} id="defaultPkgExp_Dinner" type="number" allowDefault onlyDigits onlyZeroOne isLoading={isLoading} object={activity}  maxLength={1} />*/}
                                                <label className="form-label" htmlFor="defaultPkgExp_Dinner">
                                                    {t("dinner")}
                                                </label>
                                                <input
                                                    name="defaultPkgExp_Dinner"
                                                    className="form-control"
                                                    value={activity.defaultPkgExp_Dinner ?? ''} min={0}
                                                    max={1} type="number"
                                                    onChange={action((e) => {
                                                        if (e.target.value.length > 1) {
                                                            activity.defaultPkgExp_Dinner = e.target.value[e.target.value.length - 1];
                                                        } else {
                                                            activity.defaultPkgExp_Dinner = e.target.value;
                                                        }
                                                    })}
                                                    onKeyPress={isZeroOne} />
                                            </Col>
                                            <Col>
                                                <label className="form-label" htmlFor="defaultPkgExp_Lodging">
                                                    {t("lodging")}
                                                </label>
                                                <input
                                                    name="defaultPkgExp_Lodging"
                                                    className="form-control"
                                                    value={activity.defaultPkgExp_Lodging ?? ''} min={0}
                                                    max={1} type="number"
                                                    onChange={action((e) => {
                                                        if (e.target.value.length > 1) {
                                                            activity.defaultPkgExp_Lodging = e.target.value[e.target.value.length - 1];
                                                        } else {
                                                            activity.defaultPkgExp_Lodging = e.target.value;
                                                        }
                                                    })}
                                                    onKeyPress={isZeroOne} />
                                                {/*<FormText label={t("lodging")} id="defaultPkgExp_Lodging" type="number" allowDefault onlyDigits onlyZeroOne isLoading={isLoading} object={activity} maxLength={1} />*/}
                                            </Col>

                                        </Row>



                                    </Container>
                                </Col>


                            </Row>}

                        </Stack>

                    </div >

                </Card.Body>
            </Card>
        </Form>

    );
};

export default observer(ActivitiesEdit);
